/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect, useRef, useState, type ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import store from "store";
import {
  clearPlatformServiceField,
} from "actions/app";

// Components
import AppButton from "components/AppButton";
import AppContainer from "components/AppContainer";
import AppModal from "components/AppModal";
import SocialAdsAccountSelection from "components/SocialAdsAccountSelection";
import { Oval } from "react-loader-spinner";
import { deleteField, doc, updateDoc } from "firebase/firestore";

//Constant
import {
  PLATFORM_SERVICES_COLLECTION,
  USER_DATA_AND_CHATBOT_COLLECTION,
} from "constants/global/firebase-collections";

//Funtions
import {
  _onSelectAdsItem,
  actionAlert,
  isOnline,
  sweetAlert,
  updatePlatformService,
  updatePlatformServices,
  updateUserDataAndChatbot,
} from "functions/global";
import { fbAdsLogin, getFbAdsAccounts } from "functions/facebookAds";
import { getGoogleAdsAccounts } from "functions/googleAds";
import {
  getTikTokAccessToken,
  getTikTokAdvertiserAccounts,
  getTiktokAdvertiserDetail,
} from "functions/tiktokAds";
import {
  getSnapchatAccesstoken,
  getSnapchatOrganizations,
  getSnapchatUserInfo,
} from "functions/snapchatAds";
import {
  getLinkedinAccessToken,
  getLinkedinAdAccounts,
} from "functions/linkedin";
import { getTikTokSocialAccessToken } from "functions/tiktokSocial";

//Styles
import "./styles.css";
import Input from "components/Input";
import { IS_GOOGLE_DISABLED } from "constants/global/flags";
import {
  getGoogleAnalyticsAccount,
  getGoogleAnalyticsProperties,
  getGoogleAnalyticsViewIds,
} from "functions/googleAnalytics";
import { getBingAdAccounts, getBingAdsAccessToken } from "functions/bingAds";
import {
  getSpotifyAdAccounts,
  getSpotifyAdsAccessToken,
  getSpotifyBusinesses,
} from "functions/spotifyAds";
import { connectOpenAiAds } from "functions/openAiAds";
import AppText from "components/AppText";
import { useSelector } from "react-redux";
// import { ACCOUNT_ACCESS } from "constants/global";
import axios from "axios";
import { ApiServerPath } from "api_server";
import {
  ADS_TYPE_TO_LOCK_KEY,
  getAccountIdFromSelectionItem,
  getAccountLocks,
  getAdsLockRejectionMessage,
  getSocialLockRejectionMessage,
  isAdsAccountAllowed,
  isSocialIdentityAllowed,
  normalizeAdsAccountId,
} from "functions/accountLocks";
import {
  getAccountInitial,
  getAvatarColor,
  getPlatformConnectionUi,
} from "constants/platforms/connectionUi";

const AD_ACCOUNT_LOCK_TOOLTIP = (
  <div className="ad-account-picker__lock-tooltip">
    <p className="ad-account-picker__lock-tooltip-title">
      Connection can't be changed
    </p>
    <p>This workspace is already using another account or page. Connections are locked after a campaign or social post is created.</p>
    <p>To use a different account or page, create a new workspace.</p>
  </div>
);

const wrapWithLockedAccountTooltip = (
  isLockedOut: boolean,
  children: ReactNode,
) => {
  if (!isLockedOut) return children;

  return (
    <Tooltip
      title={AD_ACCOUNT_LOCK_TOOLTIP}
      arrow
      placement="top"
      enterTouchDelay={0}
      componentsProps={{
        tooltip: { className: "ad-account-picker__lock-tooltip-panel" },
      }}
    >
      <span className="ad-account-picker__tooltip-trigger">{children}</span>
    </Tooltip>
  );
};

const AdsLogin = (props: any) => {
  const processedLinkedinAuthCodeRef = useRef<string | null>(null);
  const loadedSnapchatOrganizationRef = useRef<string | null>(null);

  const isCreatingAdAccount = false;
  const [loadingMoreAccounts, setLoadingMoreAccounts] = useState(false);
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null);
  const [adsAccounts, setAdsAccounts] = useState<any>([]);
  const [showModal, setShowModal] = useState(false);
  const [accountsModalType, setAccountsModalType] = useState<string>();
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [connectionMenuOpen, setConnectionMenuOpen] = useState(false);
  const [adAccountSearch, setAdAccountSearch] = useState("");
  const [pendingAdAccount, setPendingAdAccount] = useState<any>(null);
  const [expandedAccountKeys, setExpandedAccountKeys] = useState<string[]>([]);

  const [fbSwitchAccountLoader, setFbSwitchAccountLoader] = useState(false);
  const [isSubscribingFacebookAds, setIsSubscribingFacebookAds] =
    useState(false);

  const [googleSwitchAccountLoader, setGoogleSwitchAccountLoader] =
    useState(false);
  const [googleAdAccountId, setGoogleAdAccountId] = useState("");
  const [isGoogleAccManager, setIsGoogleAccManager] = useState("Yes");
  const [isAddAdAccModal, setIsAddAdAccModal] = useState(false);
  const [modalAdAccId, setModalAdAccId] = useState("");
  const [googleSelectedAdAccountList, setGoogleSelectedAdAccountList] =
    useState<string[]>([]);
  const [isShowSelectedAccIds, setIsShowSelectedAccIds] = useState(false);

  const [isTiktokSwitchAccLoading, setIsTiktokSwitchAccLoading] =
    useState(false);
  const [isTiktokConnectLoading, setIsTiktokConnectLoading] = useState(false);
  const [Account, setAccount] = useState<any>();
  const [redirectUrl, setRedirectUrl] = useState<string>();

  const [isTiktokSocialConnectLoading, setIsTiktokSocialConnectLoading] =
    useState(false);

  const [isSnapchatConnectLoading, setIsSnapchatConnectLoading] =
    useState(false);
  const [isSnapchatSwitchAccLoading, setIsSnapchatSwitchAccLoading] =
    useState(false);
  const [snapchatSwitchType, setSnapchatSwitchType] = useState("");
  const [spotifySwitchType, setSpotifySwitchType] = useState("");
  const [organizationLoader, setOrganizationLoader] = useState(false);
  const [spotifyBusinessesLoader, setSpotifyBusinessesLoader] = useState(false);
  const [snapchatAdAccounts, setSnapchatAdAccounts] = useState([]);

  const [isLinkedinConnectLoading, setIsLinkedinConnectLoading] =
    useState(false);
  const [isLinkedinSwitchAccLoading, setIsLinkedinSwitchAccLoading] =
    useState(false);

  const [isBingConnectLoading, setIsBingConnectLoading] = useState(false);
  const [isBingSwitchAccLoading, setIsBingSwitchAccLoading] = useState(false);

  const [isSpotifyConnectLoading, setIsSpotifyConnectLoading] = useState(false);
  const [isSpotifySwitchAccLoading, setIsSpotifySwitchAccLoading] =
    useState(false);

  const [isOpenAiConnectLoading, setIsOpenAiConnectLoading] = useState(false);

  const [workspaceId, setWorkspaceId] = useState();
  const [urlState, setUrlState] = useState<any>({});
  const [isExternalApi, setIsExternalApi] = useState(false);

  const [
    googleAnalyticsSwitchAccountLoader,
    setGoogleAnalyticsSwitchAccountLoader,
  ] = useState(false);
  const [
    googleAnalyticsSwitchPropertyLoader,
    setGoogleAnalyticsSwitchPropertyLoader,
  ] = useState<boolean>(false);
  const [googleAnalyticType, setGoogleAnalyticType] = useState<string>("");
  const [
    googleAnalyticsSwitchViewIdLoader,
    setGoogleAnalyticsSwitchViewIdLoader,
  ] = useState<boolean>(false);
  const [isProcessingConnection, setIsProcessingConnection] = useState(false);

  // Live Redux values — avoid stale local copies of platform connection data.
  const {
    platformServices = {},
    platformServicesLoaded = false,
    workspaceUserData = {},
    isRebilling = false,
  }: any = useSelector((state: any) => state.appReducer);

  const {
    facebookAds = {},
    googleAdwords = {},
    googleAnalytics = {},
    googleSocial = {},
    tiktokAds = {},
    tiktokSocial = {},
    snapchatAds = {},
    linkedinAds = {},
    bingAds = {},
    spotifyAds = {},
    openAiAds = {},
  } = platformServices;

  //funtions========================================================
  useEffect(() => {
    const {
      googleAdAccountId: storedGoogleAdAccountId = "",
      googleSelectedAdAccountList: storedGoogleSelectedList = [],
    } = workspaceUserData || {};

    if (googleAdwords?.id || storedGoogleAdAccountId) {
      setGoogleAdAccountId(
        storedGoogleAdAccountId || googleAdwords?.id || "",
      );
    }

    if (storedGoogleSelectedList?.length) {
      setGoogleSelectedAdAccountList(storedGoogleSelectedList);
    }
  }, [workspaceUserData, googleAdwords?.id]);

  useEffect(() => {
    const { refreshToken, organizationId } = snapchatAds as any;

    if (
      !refreshToken ||
      !organizationId ||
      loadedSnapchatOrganizationRef.current === organizationId
    ) {
      return;
    }

    loadedSnapchatOrganizationRef.current = organizationId;
    fetchSnapchatAdAccountsForOrganization(organizationId)
      .then((adAccounts) => setSnapchatAdAccounts(adAccounts))
      .catch((error) => console.log(error, "error"));
  }, [(snapchatAds as any)?.refreshToken, (snapchatAds as any)?.organizationId]);

  useEffect(() => {
    const params: any = props?.params;
    const auth_code = params?.auth_code;
    const redirect_auth_code = params?.code;
    let state: any = {};
    try {
      state = params?.state
        ? typeof params.state === "string"
          ? JSON.parse(params.state)
          : params.state
        : {};
    } catch (error) {
      console.log(error, "invalid state param");
      state = {};
    }
    const redirectUrl = params?.redirect_url;
    const id: any = params?.id || state?.id;
    const link_id: any = params?.link_id;
    const type = params?.account || state?.Account;

    console.log(type, "check type");

    if (type === "SNAPCHAT") {
      setIsSnapchatConnectLoading(true);
      _getSnapchatAccessToken(redirect_auth_code);
    } else if (type === "LINKEDIN") {
      // Guard against duplicate redirects / rerenders calling exchange multiple times.
      if (
        redirect_auth_code &&
        processedLinkedinAuthCodeRef.current !== redirect_auth_code
      ) {
        processedLinkedinAuthCodeRef.current = redirect_auth_code;
        setIsLinkedinConnectLoading(true);
        setIsProcessingConnection(true);
        _getLinkedinAccessToken(redirect_auth_code).finally(() => {
          setIsProcessingConnection(false);
        });
      }
    } else if (type === "BING_ADS") {
      _getBingAdsAccessToken(redirect_auth_code);
    } else if (type === "SPOTIFY") {
      _getSpotifyAdsAccessToken(redirect_auth_code);
    } else if (type === "TIKTOK_SOCIAL") {
      if (redirect_auth_code) {
        _getTikTokSocialAccessToken(redirect_auth_code);
      }
    } else if (type === "TIKTOK" && auth_code) {
      _getTikTokAccessToken(auth_code);
    }

    console.log(params, state, "params state");
    setAccount(params?.account || state?.Account);
    setRedirectUrl(
      (type === "TIKTOK"
        ? state?.redirectUrl?.replace(",", "&")
        : state?.redirectUrl) || redirectUrl,
    );
    setWorkspaceId(id);
    setUrlState(state);
    setIsExternalApi(link_id);
  }, [props?.params]);

  //Google
  const _getGoogleAdsAccounts = async (type: string) => {
    openAccountsModalLoading(type);
    setGoogleSwitchAccountLoader(true);
    try {
      const { refreshToken } = googleAdwords;
      const googleAdsAccounts = await getGoogleAdsAccounts(refreshToken);

      if (googleAdsAccounts?.length) {
        setAdsAccounts([...googleAdsAccounts]);
      } else {
        setShowModal(false);
        sweetAlert(
          "You don't have google ads account",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          "https://aiads.tips/connect-your-accounts",
        );
      }
    } finally {
      setIsModalLoading(false);
      setGoogleSwitchAccountLoader(false);
    }
  };

  const validateGoogleAdsAccountId = () => {
    // const { accountId } = googleAdwords;
    if (!modalAdAccId.trim()) {
      sweetAlert("Please Enter Google Ads account Id");
    } else if (modalAdAccId.trim().length < 12) {
      sweetAlert("Google Ads account Id must be of 10 characters.");
    } else {
      googleSelectedAdAccountList.push(modalAdAccId);
      setGoogleSelectedAdAccountList([...googleSelectedAdAccountList]);
      setGoogleAdAccountId(modalAdAccId);
      setIsAddAdAccModal(false);
      setModalAdAccId("");
    }
  };

  //Tiktok
  const _getTikTokAccessToken = async (authCode: any) => {

    // const { workspaceUserData = {} }: any = store.getState().appReducer;
    // const { connected_account_id = {} }: any = workspaceUserData;
    // const { tiktokAccountData = [] }: any = connected_account_id;
    try {
      setIsTiktokConnectLoading(true);
      const responseAccestoken = await getTikTokAccessToken(authCode);
      const response = await getTikTokAdvertiserAccounts(responseAccestoken);

      if (response) {
        // && (response[0].id === tiktokAccountData?.[0]?.accountId)
        if (response.length === 1) {
          const tiktokCurrencyCode = await getTiktokAdvertiserDetail(
            response[0]?.advertiser_id,
            responseAccestoken,
          );

          updatePlatformService(
            "tiktokAds.accountId",
            "tiktokAds.accountName",
            response[0],
            "tiktokAds.currencyCode",
            tiktokCurrencyCode,
          );
        }
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsTiktokConnectLoading(false);
    }
  };

  const _getTikTokAdvertiserAccounts = async (type: any) => {
    openAccountsModalLoading(type);
    try {
      setIsTiktokSwitchAccLoading(true);
      const response = await getTikTokAdvertiserAccounts();
      if (response.length) {
        setAdsAccounts([...response]);
      } else {
        setShowModal(false);
        sweetAlert(
          "You don't have tiktok ads account",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          " https://aiads.tips/connect-your-accounts",
        );
      }
    } catch (error) {
      console.log(error);
      setShowModal(false);
    } finally {
      setIsModalLoading(false);
      setIsTiktokSwitchAccLoading(false);
    }
  };

  const getPlatformWorkspaceId = (): string | null => {
    const {
      userData = {},
      workspaceId: storeWorkspaceId,
    }: any = store.getState().appReducer;

    console.log(userData, 'check userData');
    console.log(workspaceId, 'check workspaceId');
    console.log(storeWorkspaceId, 'check storeWorkspaceId');
    return (
      userData?.lastSelectedWorkspace?.workspaceId ||
      workspaceId ||
      storeWorkspaceId ||
      null
    );
  };

  const deletePlatformServiceField = async (
    platformField: string,
    userDataUpdates?: Record<string, any>,
  ) => {
    const id = getPlatformWorkspaceId();
    console.log(id, 'check id')
    if (!id) {
      sweetAlert("Unable to disconnect. Workspace not found.", "error");
      return false;
    }
    try {
      // Clears the field from the active workspace platformServices doc.
      await store.dispatch(clearPlatformServiceField(platformField, [id]));

      if (userDataUpdates) {
        await updateDoc(
          doc(USER_DATA_AND_CHATBOT_COLLECTION, id),
          userDataUpdates,
        );
      }

      return true;
    } catch (error) {
      console.log(error, "disconnect error");
      sweetAlert("Failed to disconnect account. Please try again.", "error");
      return false;
    }
  };

  const removeTikTokPlatform = () => {
    deletePlatformServiceField("tiktokAds", {
      tiktokConversionGoal: deleteField(),
      tiktokPixelId: deleteField(),
    });
  };

  // Tiktok Social
  const _getTikTokSocialAccessToken = async (authCode: any) => {
    try {
      setIsTiktokSocialConnectLoading(true);
      setIsProcessingConnection(true);
      await getTikTokSocialAccessToken(authCode);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsTiktokSocialConnectLoading(false);
      setIsProcessingConnection(false);
    }
  };

  const removeTikTokSocialPlatform = () => {
    deletePlatformServiceField("tiktokSocial");
  };

  // SNAPCHAT AD
  const _getSnapchatAccessToken = async (code: any) => {

    // const { workspaceUserData = {} }: any = store.getState().appReducer;
    // const { connected_account_id = {} }: any = workspaceUserData;
    // const { snapchatAccountData = [] }: any = connected_account_id;
    try {
      const accessToken = await getSnapchatAccesstoken(code);
      if (accessToken) {
        await getSnapchatUserInfo(accessToken);
        const response = await getSnapchatOrganizations(accessToken);
        if (response?.length) {
          // setSnapchatOrganizations(response);
          // && (response?.[0]?.id === snapchatAccountData?.[0]?.accountId)
          if (response?.length === 1) {
            updatePlatformServices(
              "snapchatAds.organizationId",
              response[0]?.id || "",
            );
            updatePlatformServices(
              "snapchatAds.organizationName",
              response[0]?.name || "",
            );

            setSnapchatAdAccounts(response[0].ad_accounts || []);
            loadedSnapchatOrganizationRef.current = response[0]?.id || "";

            if (response[0].ad_accounts?.length === 1) {
              updatePlatformService(
                "snapchatAds.accountId",
                "snapchatAds.accountName",
                response[0].ad_accounts[0],
                "snapchatAds.currencyCode",
              );
            }
          }
        }
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsSnapchatConnectLoading(false);
    }
  };

  const _getSnapchatOrganizations = async (type: any) => {
    try {
      setOrganizationLoader(true);
      const response = await getSnapchatOrganizations();
      if (response?.length) {
        setShowModal(true);
        setAccountsModalType(type);
        setAdsAccounts([...response]);
        setSnapchatSwitchType("ORGANIZATION");
      } else {
        sweetAlert(
          "You don't have snapchat ads account",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          " https://aiads.tips/connect-your-accounts",
        );
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setOrganizationLoader(false);
    }
  };

  // Ad accounts come nested inside the organizations response, so they have to be
  // resolved again whenever they are not already in local state.
  const fetchSnapchatAdAccountsForOrganization = async (
    organizationId: string,
  ) => {
    const organizations = await getSnapchatOrganizations();
    const organization = organizations?.find(
      (item: any) => item?.id === organizationId,
    );
    return organization?.ad_accounts || [];
  };

  const _getSnapchatAdAccounts = async (type: any) => {
    openAccountsModalLoading(type);
    try {
      setIsSnapchatSwitchAccLoading(true);
      let adAccounts: any[] = snapchatAdAccounts;
      const organizationId = (snapchatAds as any)?.organizationId;

      if (!adAccounts?.length && organizationId) {
        adAccounts = await fetchSnapchatAdAccountsForOrganization(
          organizationId,
        );
        setSnapchatAdAccounts(adAccounts as any);
        loadedSnapchatOrganizationRef.current = organizationId;
      }

      if (adAccounts?.length) {
        setAdsAccounts([...adAccounts]);
        setSnapchatSwitchType("ACCOUNT");
      } else {
        setShowModal(false);
        sweetAlert(
          "You don't have snapchat ads account",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          " https://aiads.tips/connect-your-accounts",
        );
      }
    } catch (error) {
      console.log(error, "error");
      setShowModal(false);
    } finally {
      setIsModalLoading(false);
      setIsSnapchatSwitchAccLoading(false);
    }
  };

  const removeSnapchatPlatform = () => {
    deletePlatformServiceField("snapchatAds");
  };

  // LINKEDIN AD
  const _getLinkedinAccessToken = async (code: any) => {
    try {
      await getLinkedinAccessToken(code);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsLinkedinConnectLoading(false);
    }
  };

  const _getLinkedinAdAccounts = async (type: any) => {
    openAccountsModalLoading(type);
    try {
      setIsLinkedinSwitchAccLoading(true);
      const response = await getLinkedinAdAccounts();
      if (response?.length) {
        setAdsAccounts([...response]);
      } else {
        setShowModal(false);
        sweetAlert(
          "You don't have Linkedin ads account",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          " https://aiads.tips/connect-your-accounts",
        );
      }
    } catch (error) {
      console.log(error, "error");
      setShowModal(false);
    } finally {
      setIsModalLoading(false);
      setIsLinkedinSwitchAccLoading(false);
    }
  };

  const removeLinkedinPlatform = () => {
    deletePlatformServiceField("linkedinAds");
  };

  // Spotify Ads
  const _getSpotifyAdsAccessToken = async (code: any) => {
    try {
      await getSpotifyAdsAccessToken(code);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsSpotifyConnectLoading(false);
    }
  };

  const _getSpotifyAdAccounts = async (type: any) => {
    openAccountsModalLoading(type);
    try {
      setIsSpotifySwitchAccLoading(true);
      const response = await getSpotifyAdAccounts();
      if (response?.length) {
        setAdsAccounts([...response]);
        setSpotifySwitchType("ACCOUNT");
      } else {
        setShowModal(false);
        sweetAlert(
          "You don't have Spotify ads account",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          " https://aiads.tips/connect-your-accounts",
        );
      }
    } catch (error) {
      console.log(error, "error");
      setShowModal(false);
    } finally {
      setIsModalLoading(false);
      setIsSpotifySwitchAccLoading(false);
    }
  };

  const _getSpotifyBusinesses = async (type: any) => {
    try {
      setSpotifyBusinessesLoader(true);
      const response = await getSpotifyBusinesses();
      if (response?.length) {
        setShowModal(true);
        setAccountsModalType(type);
        setAdsAccounts([...response]);
        setSpotifySwitchType("BUSINESS");
      } else {
        sweetAlert(
          "You don't have Spotify business",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          " https://aiads.tips/connect-your-accounts",
        );
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setSpotifyBusinessesLoader(false);
    }
  };

  // Bing Ads

  const _getBingAdsAccessToken = async (code: any) => {
    try {
      await getBingAdsAccessToken(code);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsBingConnectLoading(false);
    }
  };

  const removeBingAdPlatform = () => {
    deletePlatformServiceField("bingAds");
  };

  const removeSpotifyAdPlatform = () => {
    deletePlatformServiceField("spotifyAds");
  };

  const removeOpenAiAdPlatform = () => {
    deletePlatformServiceField("openAiAds");
  };

  const _connectOpenAiAds = async (apiKey: string) => {
    try {
      setIsOpenAiConnectLoading(true);
      await connectOpenAiAds(apiKey);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsOpenAiConnectLoading(false);
    }
  };

  const _getBingAdAccounts = async (type: any) => {
    openAccountsModalLoading(type);
    try {
      setIsBingSwitchAccLoading(true);
      const response = await getBingAdAccounts();
      if (response?.length) {
        setAdsAccounts([...response]);
      } else {
        setShowModal(false);
        sweetAlert(
          "You don't have Bing ads account",
          "error",
          null,
          null,
          "https://aiads.tips/connect-your-accounts",
          " https://aiads.tips/connect-your-accounts",
        );
      }
    } catch (error) {
      console.log(error, "error");
      setShowModal(false);
    } finally {
      setIsModalLoading(false);
      setIsBingSwitchAccLoading(false);
    }
  };

  //Analytics
  const _getGoogleAnalyticsAccounts = async (type: string) => {
    openAccountsModalLoading(type);
    setGoogleAnalyticsSwitchAccountLoader(true);

    try {
      const { refreshToken } = googleAnalytics;
      const googleAnalyticsAccounts = await getGoogleAnalyticsAccount(
        refreshToken,
      );

      if (googleAnalyticsAccounts?.error) {
        setShowModal(false);
        sweetAlert(googleAnalyticsAccounts?.error);
      } else {
        setAccountsModalType(type);
        setGoogleAnalyticType("accounts");
        setAdsAccounts([...googleAnalyticsAccounts]);
      }
    } finally {
      setIsModalLoading(false);
      setGoogleAnalyticsSwitchAccountLoader(false);
    }
  };

  const _getGoogleAnalyticsProperties = async (type: string) => {
    setGoogleAnalyticsSwitchPropertyLoader(true);

    const { refreshToken, accountId } = googleAnalytics;
    const obj = {
      refreshToken,
      accountId,
    };
    const googleAnalyticsProperties = await getGoogleAnalyticsProperties(obj);

    if (googleAnalyticsProperties?.length) {
      setShowModal(true);
      setAccountsModalType(type);
      setGoogleAnalyticType("properties");
      setAdsAccounts([...googleAnalyticsProperties]);
    } else {
      sweetAlert(`You don't have google analytics property.`);
    }

    setGoogleAnalyticsSwitchPropertyLoader(false);
  };

  const _getGoogleAnalyticsViewIds = async (type: string) => {
    setGoogleAnalyticsSwitchViewIdLoader(true);

    const { refreshToken, accountId, propertyId } = googleAnalytics;
    const obj = {
      accountId,
      refreshToken,
      propertyId,
    };

    const googleAnalyticsviewIds = await getGoogleAnalyticsViewIds(obj);

    if (googleAnalyticsviewIds?.length) {
      setShowModal(true);
      setAccountsModalType(type);
      setGoogleAnalyticType("views");
      setAdsAccounts([...googleAnalyticsviewIds]);
    } else {
      sweetAlert(`You don't have google analytics View id.`);
    }

    setGoogleAnalyticsSwitchViewIdLoader(false);
  };

  const onSelectGoogleAnalytics = (
    idKey: any,
    nameKey: any,
    { id, name, displayName, ad_accounts = [] }: any,
  ) => {
    id = id || name;
    name = displayName || name;

    const { userData = {} }: any = store.getState().appReducer;
    const { lastSelectedWorkspace = {} } = userData;
    const { workspaceId } = lastSelectedWorkspace;
    console.log("see here whats", userData);

    if (accountsModalType === "SPOTIFY" && spotifySwitchType === "BUSINESS") {
      updateDoc(doc(PLATFORM_SERVICES_COLLECTION, workspaceId), {
        [idKey]: id,
        [nameKey]: name,
        "spotifyAds.accountId": "",
        "spotifyAds.accountName": "",
      });
    } else {
      updateDoc(doc(PLATFORM_SERVICES_COLLECTION, workspaceId), {
        [idKey]: id,
        [nameKey]: name,
      });
    }

    if (
      accountsModalType === "SNAPCHAT" &&
      snapchatSwitchType === "ORGANIZATION"
    ) {
      setSnapchatAdAccounts(ad_accounts);
      loadedSnapchatOrganizationRef.current = id;
    }

    if (googleAnalyticType === "accounts") {
      updateDoc(doc(PLATFORM_SERVICES_COLLECTION, workspaceId), {
        "googleAnalytics.propertyId": "",
        "googleAnalytics.propertyName": "",
        "googleAnalytics.viewId": "",
        "googleAnalytics.viewName": "",
      });
    }

    if (googleAnalyticType === "properties") {
      updateDoc(doc(PLATFORM_SERVICES_COLLECTION, workspaceId), {
        "googleAnalytics.viewId": "",
        "googleAnalytics.viewName": "",
      });
    }
    setShowModal(false);
  };

  //Global

  const validateAccountSelection = (item: any, type: any): boolean => {
    const locks = getAccountLocks(workspaceUserData);

    if (type === "GOOGLE_SOCIAL") {
      const channelId = getAccountIdFromSelectionItem(item, type);
      if (
        !isSocialIdentityAllowed(locks, "youtube", { channelId })
      ) {
        sweetAlert(getSocialLockRejectionMessage(locks, "youtube"), "error");
        return false;
      }
      return true;
    }

    if (type === "TIKTOK_SOCIAL") {
      const openId = getAccountIdFromSelectionItem(item, type);
      if (!isSocialIdentityAllowed(locks, "tiktok", { openId })) {
        sweetAlert(getSocialLockRejectionMessage(locks, "tiktok"), "error");
        return false;
      }
      return true;
    }

    const platformKey = ADS_TYPE_TO_LOCK_KEY[type];
    if (!platformKey) return true;

    const accountId = getAccountIdFromSelectionItem(item, type);
    if (!isAdsAccountAllowed(locks, platformKey, accountId)) {
      sweetAlert(getAdsLockRejectionMessage(locks, platformKey), "error");
      return false;
    }
    return true;
  };

  const onSelectAdsItem = async (
    item: any,
    idKey: any,
    idName: any,
    currencyKey: any,
    type: any,
  ) => {
    if (!validateAccountSelection(item, type)) {
      return;
    }

    setIsModalLoading(true);

    const isSelected = await _onSelectAdsItem(
      item,
      idKey,
      idName,
      currencyKey,
      type,
      workspaceId,
      // googleAdwords
    );

    if (!isSelected) {
      setShowModal(false);
      setIsModalLoading(false);
    }
  };

  const handleLoadMore = () => {
    if (nextPageUrl) {
      fetchData(nextPageUrl);
    }
  };

  const fetchData = async (url: string) => {
    try {
      setLoadingMoreAccounts(true);
      const response = await fetch(url);
      const data = await response.json();
      setAdsAccounts((prevAdAccounts: any) => [
        ...prevAdAccounts,
        ...data.data,
      ]);
      setNextPageUrl(data.paging.next);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingMoreAccounts(false);
    }
  };

  const openAccountsModalLoading = (type: string) => {
    setAccountsModalType(type);
    setAdsAccounts([]);
    setPendingAdAccount(null);
    setAdAccountSearch("");
    setIsModalLoading(true);
    setShowModal(true);
  };

  const switchAccount = async (type: any) => {
    if (isOnline()) {
      if (type === "FACEBOOK" || type === "INSTAGRAM") {
        openAccountsModalLoading(type);
        setFbSwitchAccountLoader(true);
        try {
          const fbAccounts: any = await getFbAdsAccounts("debugmessage3");

          if ((fbAccounts.data as any)?.length) {
            setAdsAccounts([...fbAccounts.data]);
            setNextPageUrl(fbAccounts.paging.next);
          } else {
            setShowModal(false);
            sweetAlert(
              "You don't have facebook ads account",
              "error",
              null,
              null,
              "https://aiads.tips/connect-your-accounts",
              " https://aiads.tips/connect-your-accounts",
            );
          }
        } finally {
          setIsModalLoading(false);
          setFbSwitchAccountLoader(false);
        }
      } else if (type === "GOOGLE_ANALYTICS") {
        _getGoogleAnalyticsAccounts(type);
      } else if (type === "TIKTOK") {
        if (
          (tiktokAds as any)?.refreshToken ||
          (tiktokAds as any)?.mobileRefreshToken
        ) {
          await _getTikTokAdvertiserAccounts(type);
        } else {
          removeTikTokPlatform();
        }
      } else if (type === "SNAPCHAT") {
        if ((snapchatAds as any)?.refreshToken) {
          await _getSnapchatAdAccounts(type);
        }
      } else if (type === "LINKEDIN") {
        if ((linkedinAds as any)?.accessToken) {
          await _getLinkedinAdAccounts(type);
        }
      } else if (type === "BING_ADS") {
        if ((bingAds as any)?.refreshToken) {
          await _getBingAdAccounts(type);
        }
      } else if (type === "SPOTIFY") {
        if ((spotifyAds as any)?.refreshToken) {
          await _getSpotifyAdAccounts(type);
        }
      } else {
        _getGoogleAdsAccounts(type);
      }
    } else {
      sweetAlert(
        "Please make sure your device connected to internet!",
        null,
        "error",
      );
    }
  };

  const cleanRedirectUrl = (url: string | undefined) => {
    if (!url) return "";
    // Remove any double quotes from the URL
    return url.replace(/"/g, "");
  };

  const handleCancel = () => {
    const cleanedRedirectUrl = cleanRedirectUrl(redirectUrl);

    if (
      Account === "LINKEDIN" ||
      Account === "TIKTOK" ||
      Account === "SNAPCHAT" ||
      Account === "BING_ADS" ||
      Account === "SPOTIFY" ||
      Account === "OPENAI_ADS" ||
      Account === "TIKTOK_SOCIAL" ||
      !cleanedRedirectUrl
    ) {
      self.close();
      return;
    }

    window.open(
      `${cleanedRedirectUrl}&state=${JSON.stringify(urlState)}`,
      "_self",
    );
  };

  const removeFacebookPlatform = () => {
    deletePlatformServiceField("facebookAds", {
      pixelId: deleteField(),
      conversionGoal: deleteField(),
      lastSelectedFbPage: deleteField(),
      lastSelectedInstaAcc: deleteField(),
      isInstagram: deleteField(),
    });
  };

  const removeGooglePlatform = () => {
    deletePlatformServiceField("googleAdwords");
  };

  const removeGoogleSocialPlatform = () => {
    deletePlatformServiceField("googleSocial");
  };

  const removeGoogleAnalyticsPlatform = () => {
    deletePlatformServiceField("googleAnalytics");
  };

  const getCurrentPlatformDetails = () => {
    switch (Account) {
      case "FACEBOOK":
      case "INSTAGRAM":
        return facebookAds;
      case "TIKTOK":
        return tiktokAds;
      case "TIKTOK_SOCIAL":
        return tiktokSocial;
      case "GOOGLE_SOCIAL":
        return googleSocial;
      case "SNAPCHAT":
        return snapchatAds;
      case "LINKEDIN":
        return linkedinAds;
      case "BING_ADS":
        return bingAds;
      case "SPOTIFY":
        return spotifyAds;
      case "OPENAI_ADS":
        return openAiAds;
      case "GOOGLE_ANALYTICS":
        return googleAnalytics;
      default:
        return googleAdwords;
    }
  };

  const isPlatformConnected = () => {
    const details: any = getCurrentPlatformDetails() || {};
    if (Account === "OPENAI_ADS") {
      return !!(details?.isConnected && details?.apiKey);
    }
    if (Account === "TIKTOK" || Account === "TIKTOK_SOCIAL") {
      return !!(
        details?.refreshToken ||
        details?.accountId ||
        details?.accessToken
      );
    }
    if (Account === "GOOGLE_SOCIAL") {
      return !!(
        details?.refreshToken ||
        details?.channelName ||
        details?.isConnected
      );
    }
    return !!(
      details?.isConnected ||
      details?.refreshToken ||
      details?.accessToken
    );
  };

  const canAcceptConnection = () => {
    return (
      (Account === "GOOGLE" &&
        googleAdwords?.refreshToken &&
        (googleAdwords?.accountId || isRebilling)) ||
      (Account === "GOOGLE_SOCIAL" && googleSocial?.refreshToken) ||
      (Account === "FACEBOOK" &&
        facebookAds?.refreshToken &&
        (facebookAds?.accountId || isRebilling)) ||
      (Account === "INSTAGRAM" &&
        facebookAds?.refreshToken &&
        (facebookAds?.accountId || isRebilling)) ||
      (Account === "TIKTOK" && tiktokAds?.accountId) ||
      (Account === "TIKTOK_SOCIAL" && tiktokSocial?.accessToken) ||
      (Account === "LINKEDIN" && linkedinAds?.accountId) ||
      (Account === "SNAPCHAT" && snapchatAds?.accountId) ||
      (Account === "BING_ADS" && bingAds?.accountId) ||
      (Account === "SPOTIFY" && spotifyAds?.accountId) ||
      (Account === "OPENAI_ADS" && openAiAds?.accountId) ||
      (Account === "GOOGLE_ANALYTICS" &&
        googleAnalytics?.accountId &&
        googleAnalytics?.propertyId &&
        (googleAnalytics?.propertyId?.split("-")?.[0] !== "UA" ||
          googleAnalytics?.viewId))
    );
  };

  const canSkipAdAccount = () => {
    return (
      (Account === "FACEBOOK" &&
        !facebookAds?.accountId &&
        facebookAds?.refreshToken) ||
      (Account === "INSTAGRAM" &&
        !facebookAds?.accountId &&
        facebookAds?.refreshToken) ||
      (Account === "GOOGLE" &&
        !googleAdwords?.accountId &&
        googleAdwords?.refreshToken) ||
      (Account === "GOOGLE_SOCIAL" && googleSocial?.refreshToken) ||
      (Account === "LINKEDIN" &&
        !linkedinAds?.accountId &&
        linkedinAds?.accessToken) ||
      (Account === "TIKTOK" && !tiktokAds?.accountId && tiktokAds?.refreshToken) ||
      (Account === "TIKTOK_SOCIAL" && tiktokSocial?.accessToken)
    );
  };

  const performDisconnectPlatform = async () => {
    if (Account === "FACEBOOK" || Account === "INSTAGRAM") {
      await removeFacebookPlatform();
    } else if (Account === "TIKTOK") {
      await removeTikTokPlatform();
    } else if (Account === "TIKTOK_SOCIAL") {
      await removeTikTokSocialPlatform();
    } else if (Account === "GOOGLE_SOCIAL") {
      await removeGoogleSocialPlatform();
    } else if (Account === "SNAPCHAT") {
      await removeSnapchatPlatform();
    } else if (Account === "LINKEDIN") {
      await removeLinkedinPlatform();
    } else if (Account === "BING_ADS") {
      await removeBingAdPlatform();
    } else if (Account === "SPOTIFY") {
      await removeSpotifyAdPlatform();
    } else if (Account === "OPENAI_ADS") {
      await removeOpenAiAdPlatform();
    } else if (Account === "GOOGLE_ANALYTICS") {
      await removeGoogleAnalyticsPlatform();
    } else {
      await removeGooglePlatform();
    }
  };

  const handleDisconnectPlatform = () => {
    setConnectionMenuOpen(false);
    const platformUi = getPlatformConnectionUi(Account);

    actionAlert(
      `Are you sure you want to disconnect your ${platformUi.brandName} account? If this workspace is locked to an account, you must reconnect the same one after expiry.`,
      () => {
        performDisconnectPlatform();
      },
      "Disconnect",
      "Cancel",
      true,
    );
  };

  const getAccountChildren = (item: any): any[] =>
    item?.child || item?.childAccounts || item?.ad_accounts || [];

  const getAccountNodeKey = (account: any, index = 0, parentPath = ""): string => {
    const id =
      account?.customerId ||
      account?.advertiser_id ||
      account?.id ||
      account?.account_id ||
      account?.name ||
      account?.displayName ||
      account?.advertiser_name ||
      index;
    return `${parentPath}${String(id)}`;
  };

  const filterAccountTree = (items: any[] = [], query = ""): any[] => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return items;

    return items.reduce((acc: any[], item: any) => {
      const children = getAccountChildren(item);
      const filteredChildren = filterAccountTree(children, normalized);
      const { name, id } = getAdAccountDisplay(item);
      const selfMatch =
        name.toLowerCase().includes(normalized) ||
        String(id).toLowerCase().includes(normalized);

      if (!selfMatch && !filteredChildren.length) {
        return acc;
      }

      const next = { ...item };
      if (children.length) {
        const nextChildren = selfMatch ? children : filteredChildren;
        if (item.child) next.child = nextChildren;
        else if (item.childAccounts) next.childAccounts = nextChildren;
        else if (item.ad_accounts) next.ad_accounts = nextChildren;
        else next.child = nextChildren;
      }
      acc.push(next);
      return acc;
    }, []);
  };

  const collectExpandableKeys = (
    items: any[] = [],
    parentPath = "",
    keys: string[] = [],
  ) => {
    items.forEach((item, index) => {
      const key = getAccountNodeKey(item, index, parentPath);
      const children = getAccountChildren(item);
      if (children.length) {
        keys.push(key);
        collectExpandableKeys(children, `${key}/`, keys);
      }
    });
    return keys;
  };

  const getFlatAdAccounts = () => {
    const flatten = (items: any[] = []): any[] => {
      return items.reduce((acc: any[], item: any) => {
        const children = getAccountChildren(item);
        if (children?.length) {
          // Keep expanding nested managers, and also keep sibling top-level
          // accounts that appear later in the root array.
          return [...acc, ...flatten(children)];
        }
        return [...acc, item];
      }, []);
    };

    const flat = flatten(adsAccounts || []);
    // Same Google client can appear under a manager AND as a top-level row
    const seen = new Set<string>();
    return flat.filter((account: any) => {
      const accountId =
        getAccountIdFromSelectionItem(
          account,
          accountsModalType || Account || "",
        ) ||
        account?.customerId ||
        account?.id ||
        account?.advertiser_id ||
        account?.account_id;
      const key = normalizeAdsAccountId(accountId);
      if (!key) return true;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const getAdAccountDisplay = (account: any) => {
    const modalType = accountsModalType || Account;
    const name =
      account?.name ||
      account?.advertiser_name ||
      account?.displayName ||
      account?.title ||
      account?.accountName ||
      "Ad account";
    // Prefer customerId for Google Ads (API shape)
    const id =
      account?.customerId ||
      account?.id ||
      account?.advertiser_id ||
      account?.account_id ||
      "";
    const statusRaw =
      account?.account_status ??
      account?.status ??
      account?.accountStatus ??
      "";
    const statusUpper = String(statusRaw || "").toUpperCase();

    // Meta numeric: 1 = ACTIVE. Google: ENABLED / 2 = active.
    const isGoogle = modalType === "GOOGLE" || modalType === "GOOGLE_ANALYTICS";
    const isActive = isGoogle
      ? statusUpper === "ENABLED" ||
      statusRaw === 2 ||
      statusRaw === "2" ||
      !statusRaw
      : statusRaw === 1 ||
      statusRaw === "1" ||
      statusUpper === "ACTIVE" ||
      statusUpper === "ENABLED" ||
      !statusRaw;

    const statusLabel = isActive
      ? "Active"
      : statusUpper === "SUSPENDED"
        ? "Suspended"
        : statusUpper === "CANCELED" || statusUpper === "CANCELLED"
          ? "Canceled"
          : statusUpper === "CLOSED"
            ? "Closed"
            : "Deactivated";

    return { name, id, isActive, statusLabel };
  };

  const handleAccept = async () => {
    const cleanedRedirectUrl = cleanRedirectUrl(redirectUrl);
    console.log(cleanedRedirectUrl, "cleaned redirectUrl");

    if (
      IS_GOOGLE_DISABLED &&
      Account === "GOOGLE" &&
      googleAdwords?.refreshToken &&
      googleSelectedAdAccountList.length &&
      googleAdAccountId
    ) {
      updateUserDataAndChatbot("googleAdAccountId", googleAdAccountId);
      updateUserDataAndChatbot(
        "googleSelectedAdAccountList",
        googleSelectedAdAccountList,
      );

      if (isGoogleAccManager === "Yes") {
        actionAlert(
          "Please accept the invitation email from Advert Generator AI Ads.",
          () =>
            window.open(
              `${cleanedRedirectUrl} & state= ${JSON.stringify(urlState)}`,
              "_self",
            ),
          "Ok",
          "",
          false,
          "https://ads.google.com/aw/accountaccess/managers?ocid=307883457&euid=68984915&__u=8197267835&uscid=307883457&__c=3681439993&authuser=0&subid=ae-en-et-g-aw-c-home-awhp_xin1_signin%21o2-awhp-hv-01-22",
          "Click here to accept Invitation",
        );
      } else {
        actionAlert(
          "Please have your Google Ad Account Admin accept the invitation email from Advert Generator AI Ads.",
          () =>
            window.open(
              `${cleanedRedirectUrl}&state=${JSON.stringify(urlState)}`,
              "_self",
            ),
          "Ok",
          "",
          false,
        );
      }
    } else {
      console.log(facebookAds, "facebookAd");

      if (Account === "FACEBOOK") {
        try {
          setIsSubscribingFacebookAds(true);
          await axios.post(
            `${ApiServerPath.API_SERVER_BASE_URL}${ApiServerPath.SUBSCRIBE_FB_ADS_ACCOUNT}`,
            {
              accessToken: facebookAds?.refreshToken,
              adAccountId: facebookAds?.accountId,
            }
          );
        } catch (error) {
          console.log(error, "error");
        } finally {
          setIsSubscribingFacebookAds(false);
        }
      }

      if (!cleanedRedirectUrl) {
        self.close();
      } else if (Account === "FACEBOOK" && !facebookAds?.accountId) {
        window.open(
          `${cleanedRedirectUrl}&isFbNotConnected=true&state=${JSON.stringify(
            urlState,
          )}`,
          "_self",
        );
      } else {
        if (
          Account === "LINKEDIN" ||
          Account === "TIKTOK" ||
          Account === "SNAPCHAT" ||
          Account === "BING_ADS" ||
          Account === "SPOTIFY" ||
          Account === "OPENAI_ADS" ||
          Account === "TIKTOK_SOCIAL"
        ) {
          if (Account === "LINKEDIN" && linkedinAds?.accountId) {
            updateUserDataAndChatbot("adsPlatforms", [Account]);
          } else if (Account === "TIKTOK" && tiktokAds?.accountId) {
            updateUserDataAndChatbot("adsPlatforms", [Account]);
          } else if (Account === "SNAPCHAT" && snapchatAds?.accountId) {
            updateUserDataAndChatbot("adsPlatforms", [Account]);
          } else if (Account === "BING_ADS" && bingAds?.accountId) {
            updateUserDataAndChatbot("adsPlatforms", [Account]);
          } else if (Account === "SPOTIFY" && spotifyAds?.accountId) {
            updateUserDataAndChatbot("adsPlatforms", [Account]);
          } else if (Account === "OPENAI_ADS" && openAiAds?.accountId) {
            updateUserDataAndChatbot("adsPlatforms", [Account]);
          }

          self.close();
        } else {
          window.open(
            `${cleanedRedirectUrl}${Object.keys(urlState).length
              ? `&state=${JSON.stringify(urlState)}`
              : ""
            }`,
            "_self",
          );
        }
      }
    }
  };

  //Render============================================================

  // Google ad disabled
  const renderAddAdAccountModal = () => {
    return (
      <AppModal
        modalWidth={"sm"}
        open={isAddAdAccModal}
        handleClose={() => setIsAddAdAccModal(false)}
      >
        <div className='google-ad-account-modal-container'>
          <p className='google-ad-account-input-label'>
            <AppText>Enter your ad account id</AppText>
          </p>
          <Input
            placeholder='Example: 111-000-1234'
            value={modalAdAccId}
            onChange={(e: any) => {
              if (e.target.value.length === 3) {
                const text = e.target.value.substring(0, 3) + "-";
                setModalAdAccId(text);
              } else if (e.target.value.length === 7) {
                const text = e.target.value.substring(0, 7) + "-";
                setModalAdAccId(text);
              } else {
                setModalAdAccId(e.target.value);
              }
            }}
            maxLength={12}
            onKeyUp={(e: any) => {
              if (e.key === "Backspace") {
                if (e.target.value.length === 4) {
                  setModalAdAccId(e.target.value.substring(0, 3));
                } else if (e.target.value.length === 8) {
                  setModalAdAccId(e.target.value.substring(0, 7));
                }
              }
            }}
            inputChildClassName='google-disable-ad-account-input'
          />
          <AppButton
            title='Add'
            onClick={validateGoogleAdsAccountId}
            className={"add-google-acc-id-btn"}
          />
        </div>
      </AppModal>
    );
  };

  const renderAdAccountIdsList = () => {
    return (
      <AppModal
        modalWidth={"xs"}
        open={isShowSelectedAccIds}
        handleClose={() => setIsShowSelectedAccIds(false)}
      >
        <div className='google-disable-acc-modal'>
          <p className='google-disable-acc-modal-heading'>
            <AppText>Ad accounts</AppText>
          </p>
          {googleSelectedAdAccountList.map((item: string, index: number) => {
            return (
              <div
                className='google-disable-acc-modal-container'
                onClick={() => {
                  setGoogleAdAccountId(item);
                  setIsShowSelectedAccIds(false);
                }}
              >
                <img
                  alt={""}
                  className={"tree-view-icon"}
                  src={"images/global/user-fill.png"}
                />
                <p className='google-disable-acc-modal-text'>{item}</p>
              </div>
            );
          })}
        </div>
      </AppModal>
    );
  };

  // Google ad disabled

  const _renderAdAccounts = () => {
    const isTikTok = accountsModalType === "TIKTOK";
    const isFacebook =
      accountsModalType === "FACEBOOK" || accountsModalType === "INSTAGRAM";
    const isSnapchat = accountsModalType === "SNAPCHAT";
    const isLinkedin = accountsModalType === "LINKEDIN";
    const isBingAds = accountsModalType === "BING_ADS";
    const isSpotifyAds = accountsModalType === "SPOTIFY";

    const isGoogleAnalytics = accountsModalType === "GOOGLE_ANALYTICS";
    const isSnapchatOrganization =
      (accountsModalType === "SNAPCHAT" &&
        snapchatSwitchType === "ORGANIZATION") ||
      (accountsModalType === "SPOTIFY" && spotifySwitchType === "BUSINESS");

    const idKey = isFacebook
      ? "facebookAds.accountId"
      : isGoogleAnalytics
        ? googleAnalyticType === "accounts"
          ? "googleAnalytics.accountId"
          : googleAnalyticType === "properties"
            ? "googleAnalytics.propertyId"
            : "googleAnalytics.viewId"
        : isTikTok
          ? "tiktokAds.accountId"
          : isSnapchat
            ? snapchatSwitchType === "ORGANIZATION"
              ? "snapchatAds.organizationId"
              : "snapchatAds.accountId"
            : isLinkedin
              ? "linkedinAds.accountId"
              : isBingAds
                ? "bingAds.accountId"
                : isSpotifyAds
                  ? spotifySwitchType === "BUSINESS"
                    ? "spotifyAds.businessId"
                    : "spotifyAds.accountId"
                  : "googleAdwords.accountId";

    const idName = isFacebook
      ? "facebookAds.accountName"
      : isGoogleAnalytics
        ? googleAnalyticType === "accounts"
          ? "googleAnalytics.accountName"
          : googleAnalyticType === "properties"
            ? "googleAnalytics.propertyName"
            : "googleAnalytics.viewName"
        : isTikTok
          ? "tiktokAds.accountName"
          : isSnapchat
            ? snapchatSwitchType === "ORGANIZATION"
              ? "snapchatAds.organizationName"
              : "snapchatAds.accountName"
            : isLinkedin
              ? "linkedinAds.accountName"
              : isBingAds
                ? "bingAds.accountName"
                : isSpotifyAds
                  ? spotifySwitchType === "BUSINESS"
                    ? "spotifyAds.businessName"
                    : "spotifyAds.accountName"
                  : "googleAdwords.accountName";

    const currencyKey = isFacebook
      ? "facebookAds.currencyCode"
      : isTikTok
        ? "tiktokAds.currencyCode"
        : isSnapchat
          ? "snapchatAds.currencyCode"
          : isLinkedin
            ? "linkedinAds.currencyCode"
            : isBingAds
              ? "bingAds.currencyCode"
              : isSpotifyAds
                ? "spotifyAds.currencyCode"
                : "googleAdwords.currencyCode";

    const modalTitle = isSnapchatOrganization
      ? accountsModalType === "SPOTIFY"
        ? "Select business"
        : "Select organization"
      : isGoogleAnalytics
        ? googleAnalyticType === "accounts"
          ? "Select account"
          : googleAnalyticType === "properties"
            ? "Select property"
            : "Select view"
        : "Select ad account";

    const modalSubtitle = isSnapchatOrganization
      ? accountsModalType === "SPOTIFY"
        ? "Choose the business you’d like to use."
        : "Choose the organization you’d like to use."
      : "Choose the ad account you’d like to use.";

    const listItems =
      isSnapchatOrganization || isGoogleAnalytics
        ? adsAccounts || []
        : adsAccounts || [];

    const locks = getAccountLocks(workspaceUserData);
    const platformKey = ADS_TYPE_TO_LOCK_KEY[accountsModalType || ""];
    const lockedAccountId = platformKey
      ? locks?.ads?.[platformKey]?.accountId
      : undefined;

    const useTree =
      !isSnapchatOrganization &&
      !isGoogleAnalytics &&
      (adsAccounts || []).some((item: any) => getAccountChildren(item).length);

    const isGoogleAdsModal =
      accountsModalType === "GOOGLE" || Account === "GOOGLE";

    // Search — tree keeps parent/child accordion; flat list for simple cases.
    const filteredAccounts = useTree
      ? filterAccountTree(listItems, adAccountSearch)
      : (isSnapchatOrganization || isGoogleAnalytics
        ? listItems
        : getFlatAdAccounts()
      ).filter((account: any) => {
        const { name, id } = getAdAccountDisplay(account);
        const query = adAccountSearch.trim().toLowerCase();
        if (!query) return true;
        return (
          name.toLowerCase().includes(query) ||
          String(id).toLowerCase().includes(query)
        );
      });

    const searchActive = Boolean(adAccountSearch.trim());
    const openKeys = searchActive
      ? collectExpandableKeys(filteredAccounts)
      : expandedAccountKeys;

    const toggleExpanded = (key: string) => {
      setExpandedAccountKeys((prev) =>
        prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
      );
    };

    const fieldKey = idKey.split(".").pop() as string;
    const selectedId = pendingAdAccount
      ? getAdAccountDisplay(pendingAdAccount).id
      : getCurrentPlatformDetails()?.[fieldKey];

    const selectAccount = (account: any) => {
      const accountId = getAccountIdFromSelectionItem(
        account,
        accountsModalType || "",
      );
      const isLockedOut = Boolean(
        lockedAccountId &&
        platformKey &&
        !isAdsAccountAllowed(locks, platformKey, accountId),
      );
      if (isLockedOut) {
        sweetAlert(getAdsLockRejectionMessage(locks, platformKey!), "error");
        return;
      }
      setPendingAdAccount(account);
    };

    const renderAccountNode = (
      account: any,
      index: number,
      parentPath = "",
      depth = 0,
    ): any => {
      const children = getAccountChildren(account);
      const nodeKey = getAccountNodeKey(account, index, parentPath);
      const { name, id, isActive, statusLabel } = getAdAccountDisplay(account);
      const hasChildren = children.length > 0;
      const isExpanded = openKeys.includes(nodeKey);
      const accountId = getAccountIdFromSelectionItem(
        account,
        accountsModalType || "",
      );
      const isLockedOut = Boolean(
        lockedAccountId &&
        platformKey &&
        !isAdsAccountAllowed(locks, platformKey, accountId),
      );
      const isSelected =
        !hasChildren &&
        (String(selectedId) === String(id) ||
          normalizeAdsAccountId(selectedId) === normalizeAdsAccountId(id));

      return (
        <div
          key={`${nodeKey}-${index}`}
          className="ad-account-picker__tree-node"
        >
          {hasChildren ? (
            <button
              type="button"
              className={`ad-account-picker__item ad-account-picker__item--group ${isExpanded ? "ad-account-picker__item--expanded" : ""
                }`}
              style={{ paddingLeft: `${14 + depth * 16}px` }}
              onClick={() => toggleExpanded(nodeKey)}
            >
              <span
                className={`ad-account-picker__chevron ${isExpanded ? "ad-account-picker__chevron--open" : ""
                  }`}
                aria-hidden="true"
              >
                ›
              </span>
              <div
                className="ad-account-picker__avatar"
                style={{ backgroundColor: getAvatarColor(name) }}
              >
                {getAccountInitial(name)}
              </div>
              <div className="ad-account-picker__item-content">
                <p className="ad-account-picker__item-title">{name}</p>
                <p className="ad-account-picker__item-meta">
                  {children.length} account{children.length === 1 ? "" : "s"}
                  {id ? ` · ID: ${id}` : ""}
                </p>
              </div>
              {isGoogleAdsModal ? (
                <span className="ad-account-picker__mcc-tag">MCC</span>
              ) : null}
            </button>
          ) : (
            wrapWithLockedAccountTooltip(
              isLockedOut,
              <button
                type="button"
                className={`ad-account-picker__item ${isSelected ? "ad-account-picker__item--selected" : ""
                  } ${isLockedOut ? "ad-account-picker__item--disabled" : ""}`}
                style={{ paddingLeft: `${20 + depth * 16}px` }}
                disabled={isLockedOut}
                onClick={() => selectAccount(account)}
              >
                <div
                  className="ad-account-picker__avatar"
                  style={{ backgroundColor: getAvatarColor(name) }}
                >
                  {getAccountInitial(name)}
                </div>
                <div className="ad-account-picker__item-content">
                  <p className="ad-account-picker__item-title">{name}</p>
                  <p className="ad-account-picker__item-meta">
                    <span
                      className={`platform-status-dot ${isActive
                        ? "platform-status-dot--active"
                        : "platform-status-dot--inactive"
                        }`}
                    />
                    {statusLabel}
                    {id ? ` · Account ID: ${id}` : ""}
                  </p>
                </div>
                <span
                  className={`ad-account-picker__radio ${isSelected ? "ad-account-picker__radio--checked" : ""
                    }`}
                >
                  {isSelected ? "✓" : ""}
                </span>
              </button>,
            )
          )}

          {hasChildren && isExpanded ? (
            <div className="ad-account-picker__children">
              {children.map((child: any, childIndex: number) =>
                renderAccountNode(
                  child,
                  childIndex,
                  `${nodeKey}/`,
                  depth + 1,
                ),
              )}
            </div>
          ) : null}
        </div>
      );
    };

    const confirmSelection = async () => {
      if (!pendingAdAccount) {
        setShowModal(false);
        return;
      }

      if (isGoogleAnalytics || isSnapchatOrganization) {
        await onSelectGoogleAnalytics(idKey, idName, pendingAdAccount);
      } else {
        await onSelectAdsItem(
          pendingAdAccount,
          idKey,
          idName,
          currencyKey,
          accountsModalType,
        );
      }
      setShowModal(false);
      setPendingAdAccount(null);
      setAdAccountSearch("");
      setExpandedAccountKeys([]);
    };

    return (
      <AppModal
        open={showModal}
        handleClose={() => {
          setShowModal(false);
          setPendingAdAccount(null);
          setAdAccountSearch("");
          setExpandedAccountKeys([]);
        }}
        modalWidth="sm"
        className="ad-account-picker-dialog"
      >
        <div className="ad-account-picker">
          <div className="ad-account-picker__header">
            <div>
              <h3 className="ad-account-picker__title">{modalTitle}</h3>
              <p className="ad-account-picker__subtitle">{modalSubtitle}</p>
            </div>
            <button
              type="button"
              className="ad-account-picker__close"
              onClick={() => {
                setShowModal(false);
                setPendingAdAccount(null);
                setAdAccountSearch("");
                setExpandedAccountKeys([]);
              }}
              aria-label="Close"
            >
              ×
            </button>
          </div>

          <div className="ad-account-picker__search">
            <span aria-hidden="true">🔍</span>
            <input
              value={adAccountSearch}
              onChange={(e) => setAdAccountSearch(e.target.value)}
              placeholder={
                isSnapchatOrganization
                  ? accountsModalType === "SPOTIFY"
                    ? "Search businesses..."
                    : "Search organizations..."
                  : "Search ad accounts..."
              }
            />
          </div>

          <div className="ad-account-picker__list">
            {isModalLoading ? (
              <div className="ad-account-picker__loading">
                <Oval
                  height={32}
                  width={32}
                  color={"var(--color-primary)"}
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="var(--text-grey)"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              </div>
            ) : filteredAccounts.length ? (
              useTree
                ? filteredAccounts.map((account: any, index: number) =>
                  renderAccountNode(account, index),
                )
                : filteredAccounts.map((account: any, index: number) => {
                  const { name, id, isActive } =
                    getAdAccountDisplay(account);
                  const accountId = getAccountIdFromSelectionItem(
                    account,
                    accountsModalType || "",
                  );
                  const isLockedOut = Boolean(
                    lockedAccountId &&
                    platformKey &&
                    !isAdsAccountAllowed(locks, platformKey, accountId),
                  );
                  const isSelected =
                    String(selectedId) === String(id) ||
                    normalizeAdsAccountId(selectedId) ===
                    normalizeAdsAccountId(id);
                  return wrapWithLockedAccountTooltip(
                    isLockedOut,
                    <button
                      type="button"
                      key={`${normalizeAdsAccountId(id) || name}-${index}`}
                      className={`ad-account-picker__item ${isSelected ? "ad-account-picker__item--selected" : ""
                        } ${isLockedOut ? "ad-account-picker__item--disabled" : ""
                        }`}
                      disabled={isLockedOut}
                      onClick={() => selectAccount(account)}
                    >
                      <div
                        className="ad-account-picker__avatar"
                        style={{ backgroundColor: getAvatarColor(name) }}
                      >
                        {getAccountInitial(name)}
                      </div>
                      <div className="ad-account-picker__item-content">
                        <p className="ad-account-picker__item-title">
                          {name}
                        </p>
                        <p className="ad-account-picker__item-meta">
                          <span
                            className={`platform-status-dot ${isActive
                              ? "platform-status-dot--active"
                              : "platform-status-dot--inactive"
                              }`}
                          />
                          {isActive ? "Active" : "Deactivated"}
                          {id ? (
                            <>
                              <span
                                className="platform-meta-separator"
                                aria-hidden="true"
                              />
                              <span>{`Account ID: ${id}`}</span>
                            </>
                          ) : null}
                        </p>
                      </div>
                      <span
                        className={`ad-account-picker__radio ${isSelected
                          ? "ad-account-picker__radio--checked"
                          : ""
                          }`}
                      >
                        {isSelected ? "✓" : ""}
                      </span>
                    </button>,
                  );
                })
            ) : (
              <p className="ad-account-picker__empty">No accounts found.</p>
            )}
          </div>

          {nextPageUrl && isFacebook && (
            <div className="load-more-accounts-btn-container">
              <AppButton
                className="load-more-accounts-btn"
                title={"Load More Accounts"}
                loading={loadingMoreAccounts}
                onClick={handleLoadMore}
              />
            </div>
          )}

          <div className="ad-account-picker__footer">
            <button
              type="button"
              className="platform-cancel-link"
              onClick={() => {
                setShowModal(false);
                setPendingAdAccount(null);
                setAdAccountSearch("");
                setExpandedAccountKeys([]);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="platform-continue-btn"
              disabled={!pendingAdAccount && !selectedId}
              onClick={confirmSelection}
            >
              Select
            </button>
          </div>
        </div>
      </AppModal>
    );
  };

  const renderConnectionBody = () => {
    const isLoading =
      (Account === "TIKTOK" && isTiktokConnectLoading) ||
      (Account === "TIKTOK_SOCIAL" && isTiktokSocialConnectLoading) ||
      (Account === "SNAPCHAT" && isSnapchatConnectLoading) ||
      (Account === "LINKEDIN" && isLinkedinConnectLoading) ||
      (Account === "BING_ADS" && isBingConnectLoading) ||
      (Account === "SPOTIFY" && isSpotifyConnectLoading) ||
      (Account === "GOOGLE" && isCreatingAdAccount) ||
      (Account === "GOOGLE_SOCIAL" && isProcessingConnection);

    if (isLoading) {
      return (
        <div className="platform-connection-loading">
          <Oval
            height={40}
            width={40}
            color={"var(--color-primary)"}
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="var(--text-grey)"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      );
    }

    if (Account === "FACEBOOK" || Account === "INSTAGRAM") {
      return (
        <>
          <SocialAdsAccountSelection
            type={Account}
            loader={fbSwitchAccountLoader}
            adsAccountDetails={facebookAds}
            switchAccount={() => switchAccount(Account)}
            connect={() => fbAdsLogin()}
            isExternalApi={isExternalApi}
          />
          {/* <p
            onClick={() =>
              sweetAlert(
                "Tap the Edit button and tap Switch next to your Facebook Profile. Then tap Edit Settings on the Facebook connect pop-up. Make sure your page is selected there. You will then see all of the pages listed that you have access to and you can select them here.",
              )
            }
            className="fb-page-text"
          >
            Don't see your Facebook page?
          </p> */}
        </>
      );
    }

    if (Account === "TIKTOK") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={tiktokAds}
          connect={removeTikTokPlatform}
          loader={isTiktokSwitchAccLoading}
          isConnectLoading={isTiktokConnectLoading}
          switchAccount={() => switchAccount(Account)}
          state={{
            Account: "TIKTOK",
            redirectUrl: redirectUrl && redirectUrl.replace("&", ","),
            id: workspaceId,
          }}
        />
      );
    }

    if (Account === "TIKTOK_SOCIAL") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={tiktokSocial}
          connect={removeTikTokSocialPlatform}
          loader={false}
          isConnectLoading={isTiktokSocialConnectLoading}
          switchAccount={() => { }}
          state={{
            Account: "TIKTOK_SOCIAL",
            redirectUrl: redirectUrl,
            id: workspaceId,
          }}
        />
      );
    }

    if (Account === "GOOGLE_SOCIAL") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={googleSocial}
          connect={removeGoogleSocialPlatform}
          loader={false}
          isConnectLoading={isProcessingConnection}
          switchAccount={() => { }}
          state={{
            Account: "GOOGLE_SOCIAL",
            redirectUrl: redirectUrl,
            id: workspaceId,
          }}
          onConnectionStart={() => setIsProcessingConnection(true)}
          onConnectionEnd={() => setIsProcessingConnection(false)}
        />
      );
    }

    if (Account === "SNAPCHAT") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={snapchatAds}
          connect={removeSnapchatPlatform}
          loader={isSnapchatSwitchAccLoading}
          isConnectLoading={isSnapchatConnectLoading}
          switchAccount={() => switchAccount(Account)}
          switchSnapchatOrganization={() => _getSnapchatOrganizations(Account)}
          organizationLoader={organizationLoader}
          state={{ Account: "SNAPCHAT", redirectUrl, id: workspaceId }}
        />
      );
    }

    if (Account === "LINKEDIN") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={linkedinAds}
          connect={removeLinkedinPlatform}
          loader={isLinkedinSwitchAccLoading}
          isConnectLoading={isLinkedinConnectLoading}
          switchAccount={() => switchAccount(Account)}
          state={{ Account: "LINKEDIN", redirectUrl, id: workspaceId }}
        />
      );
    }

    if (Account === "BING_ADS") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={bingAds}
          connect={removeBingAdPlatform}
          loader={isBingSwitchAccLoading}
          isConnectLoading={isBingConnectLoading}
          switchAccount={() => switchAccount(Account)}
          state={{ Account: "BING_ADS", redirectUrl, id: workspaceId }}
        />
      );
    }

    if (Account === "SPOTIFY") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={spotifyAds}
          connect={removeSpotifyAdPlatform}
          loader={isSpotifySwitchAccLoading}
          isConnectLoading={isSpotifyConnectLoading}
          switchAccount={() => switchAccount(Account)}
          state={{ Account: "SPOTIFY", redirectUrl, id: workspaceId }}
          switchSnapchatOrganization={() => _getSpotifyBusinesses(Account)}
          organizationLoader={spotifyBusinessesLoader}
        />
      );
    }

    if (Account === "OPENAI_ADS") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          adsAccountDetails={openAiAds}
          connect={removeOpenAiAdPlatform}
          isConnectLoading={isOpenAiConnectLoading}
          onConnectOpenAiAds={_connectOpenAiAds}
        />
      );
    }

    if (Account === "GOOGLE_ANALYTICS") {
      return (
        <SocialAdsAccountSelection
          type={Account}
          loader={googleAnalyticsSwitchAccountLoader}
          adsAccountDetails={googleAnalytics}
          switchAccount={() => switchAccount(Account)}
          connect={removeGoogleAnalyticsPlatform}
          switchPropertyId={() => _getGoogleAnalyticsProperties(Account)}
          switchViewId={() => _getGoogleAnalyticsViewIds(Account)}
          propertyLoader={googleAnalyticsSwitchPropertyLoader}
          viewIdLoader={googleAnalyticsSwitchViewIdLoader}
        />
      );
    }

    return (
      <SocialAdsAccountSelection
        type={Account}
        adsAccountDetails={googleAdwords}
        loader={googleSwitchAccountLoader}
        switchAccount={() => switchAccount(Account)}
        connect={removeGooglePlatform}
        loading={isModalLoading}
        googleAdAccountId={googleAdAccountId}
        setGoogleAdAccountId={setGoogleAdAccountId}
        setIsGoogleAccManager={setIsGoogleAccManager}
        isGoogleAccManager={isGoogleAccManager}
        setIsAddAdAccModal={setIsAddAdAccModal}
        setIsShowSelectedAccIds={setIsShowSelectedAccIds}
        googleSelectedAdAccountList={googleSelectedAdAccountList}
        onConnectionStart={() => setIsProcessingConnection(true)}
        onConnectionEnd={() => setIsProcessingConnection(false)}
      />
    );
  };

  const platformUi = getPlatformConnectionUi(Account);
  const connected = isPlatformConnected();
  const showPrimaryAction = canAcceptConnection() || canSkipAdAccount();
  const primaryActionLabel = canAcceptConnection() ? "Connect" : "Continue";

  if (!platformServicesLoaded) {
    return (
      <AppContainer>
        <div className="platform-connection-loading">
          <Oval
            height={40}
            width={40}
            color={"var(--color-primary)"}
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="var(--text-grey)"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      {_renderAdAccounts()}
      {renderAddAdAccountModal()}
      {renderAdAccountIdsList()}

      <div className="platform-connection-card">
        <div className="platform-connection-card__top">
          <div className="platform-connection-brand">
            <img src={platformUi.logo} alt={platformUi.brandName} />
            <span>{platformUi.brandName}</span>
          </div>

          {connected && (
            <div className="platform-connected-menu">
              <button
                type="button"
                className="platform-connected-pill"
                onClick={() => setConnectionMenuOpen((prev) => !prev)}
              >
                <span className="platform-status-dot platform-status-dot--active" />
                Connected
                <span className="platform-connected-pill__chevron">▾</span>
              </button>
              {connectionMenuOpen && (
                <div className="platform-connected-dropdown">
                  <button
                    type="button"
                    className="platform-connected-dropdown__danger"
                    onClick={handleDisconnectPlatform}
                  >
                    Disconnect {platformUi.brandName}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="platform-connection-card__header">
          <h1>{platformUi.title}</h1>
          <p>
            {connected ? platformUi.connectedSubtitle : platformUi.subtitle}
          </p>
        </div>

        <div className="platform-connection-card__body">
          {renderConnectionBody()}
        </div>

        <div className="platform-connection-card__footer">
          <button
            type="button"
            className="platform-cancel-link"
            onClick={handleCancel}
            disabled={isProcessingConnection}
          >
            Cancel
          </button>

          {showPrimaryAction && (
            <button
              type="button"
              className="platform-continue-btn"
              onClick={handleAccept}
              disabled={isSubscribingFacebookAds || isProcessingConnection}
            >
              {isSubscribingFacebookAds || isProcessingConnection
                ? "Loading..."
                : primaryActionLabel}
              <span aria-hidden="true">→</span>
            </button>
          )}
        </div>
      </div>
    </AppContainer>
  );
};

export default AdsLogin;
